import { Dictionary } from '@/types/field'
import { createSelector } from 'reselect'
import { initialPaginationState, TablePagination } from '../slices/paginationSlice.ts'

export const getPaginationState = (state: Dictionary) => state.pagination

// = ====================================
//  MEMOIZED SELECTORS
// -------------------------------------
export const getPaginationInfo = (table: string) =>
    createSelector(
        (state: Dictionary) => state.pagination[table],
        (data: TablePagination = initialPaginationState?.[table]) => ({
            pageIndex: data.pageIndex,
            pageSize: data.pageSize,
            totalData: data.totalData,
            filterData: data.filterData,
            refreshTrigger: data.refreshTrigger,
            searchParams: data.searchParams,
            sorting: data.sorting
        })
    )
